const searchModule = () => {
    const modules = document.querySelectorAll('.search-module');

    modules.forEach(container => {
        if (container.dataset.initialized) return;
        container.dataset.initialized = 'true';

        const form = container.querySelector('form');
        const input = container.querySelector('input[name="search-val"]');
        if (!input) return;

        let debounceTimeout = null;
        let currentFocusIndex = -1;

        const resultsId = `search-results-${Math.floor(Math.random() * 100000)}`;
        const statusId = `search-status-${Math.floor(Math.random() * 100000)}`;

        input.setAttribute('autocomplete', 'off');
        input.setAttribute('role', 'combobox');
        input.setAttribute('aria-expanded', 'false');
        input.setAttribute('aria-haspopup', 'listbox');
        input.setAttribute('aria-autocomplete', 'list');
        input.setAttribute('aria-controls', resultsId);

        let resultsWrapper = container.querySelector('.search-module__results');
        if (!resultsWrapper) {
            resultsWrapper = document.createElement('div');
            resultsWrapper.className = 'search-module__results';
            resultsWrapper.id = resultsId;
            resultsWrapper.setAttribute('role', 'listbox');
            container.appendChild(resultsWrapper);
        }

        let statusRegion = container.querySelector('.search-module__status');
        if (!statusRegion) {
            statusRegion = document.createElement('div');
            statusRegion.className = 'search-module__status';
            statusRegion.id = statusId;
            statusRegion.setAttribute('aria-live', 'polite');
            statusRegion.setAttribute('aria-atomic', 'true');
            statusRegion.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
            container.appendChild(statusRegion);
        }

        const closeResults = () => {
            resultsWrapper.innerHTML = '';
            resultsWrapper.classList.remove('is-active');
            input.setAttribute('aria-expanded', 'false');
            input.removeAttribute('aria-activedescendant');
            currentFocusIndex = -1;
        };

        const openResults = () => {
            resultsWrapper.classList.add('is-active');
            input.setAttribute('aria-expanded', 'true');
        };

        const updateActiveDescendant = (items) => {
            items.forEach((item, idx) => {
                const isFocused = idx === currentFocusIndex;
                item.classList.toggle('is-focused', isFocused);
                item.setAttribute('aria-selected', isFocused ? 'true' : 'false');

                if (isFocused) {
                    input.setAttribute('aria-activedescendant', item.id);
                    item.scrollIntoView({ block: 'nearest' });
                }
            });

            if (currentFocusIndex === -1) {
                input.removeAttribute('aria-activedescendant');
            }
        };

        const fetchResults = (query) => {
            const ajaxUrl = window.scriptObj?.ajaxurl || '/wp-admin/admin-ajax.php';
            const nonce = window.scriptObj?.nonce || '';

            const formData = new FormData();
            formData.append('action', 'clinic_search_action');
            formData.append('q', query);
            formData.append('_wpnonce', nonce);

            fetch(ajaxUrl, { method: 'POST', body: formData })
                .then(res => res.json())
                .then(res => {
                    if (!res.success || !Array.isArray(res.data)) {
                        closeResults();
                        statusRegion.textContent = 'Błąd podczas pobierania danych.';
                        return;
                    }

                    const groups = res.data;
                    let totalResults = 0;
                    let html = '';
                    let itemCounter = 0;

                    groups.forEach(group => {
                        if (group.results && group.results.length > 0) {
                            totalResults += group.results.length;
                            html += `<div class="search-module__group" role="group" aria-label="${group.label}">`;
                            html += `<div class="search-module__group-label" aria-hidden="true">${group.label}</div>`;
                            html += `<ul class="search-module__group-list" role="presentation">`;
                            group.results.forEach(item => {
                                const optionId = `${resultsId}-opt-${itemCounter++}`;
                                html += `
                                    <li role="presentation">
                                        <a href="${item.url}" id="${optionId}" class="search-module__item" role="option" aria-selected="false">
                                            <span>${item.title}</span>
                                        </a>
                                    </li>
                                `;
                            });
                            html += `</ul></div>`;
                        }
                    });

                    if (totalResults === 0) {
                        html = `<div class="search-module__empty" role="status">Brak wyników wyszukiwania</div>`;
                        statusRegion.textContent = 'Brak wyników wyszukiwania.';
                    } else {
                        statusRegion.textContent = `Znaleziono ${totalResults} wyników. Użyj strzałek w górę i w dół, aby nawigować.`;
                    }

                    resultsWrapper.innerHTML = html;
                    openResults();
                    currentFocusIndex = -1;
                })
                .catch(() => {
                    closeResults();
                    statusRegion.textContent = 'Błąd połączenia z serwerem.';
                });
        };

        const handleEnterSubmit = () => {
            const items = Array.from(resultsWrapper.querySelectorAll('.search-module__item'));

            if (currentFocusIndex >= 0 && items[currentFocusIndex]) {
                items[currentFocusIndex].click();
                return;
            }

            const query = input.value.trim();
            if (query.length >= 2) {
                clearTimeout(debounceTimeout);
                fetchResults(query);
            }
        };

        if (form) {
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                handleEnterSubmit();
            });
        }

        input.addEventListener('input', (e) => {
            const query = e.target.value.trim();
            clearTimeout(debounceTimeout);

            if (query.length < 2) {
                closeResults();
                statusRegion.textContent = '';
                return;
            }

            debounceTimeout = setTimeout(() => {
                fetchResults(query);
            }, 300);
        });

        input.addEventListener('focus', () => {
            if (input.value.trim().length >= 2 && resultsWrapper.children.length > 0) {
                openResults();
            }
        });

        input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                handleEnterSubmit();
                return;
            }

            const items = Array.from(resultsWrapper.querySelectorAll('.search-module__item'));
            if (!items.length) return;

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (!resultsWrapper.classList.contains('is-active')) {
                    openResults();
                }
                currentFocusIndex = (currentFocusIndex + 1) % items.length;
                updateActiveDescendant(items);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (!resultsWrapper.classList.contains('is-active')) {
                    openResults();
                }
                currentFocusIndex = (currentFocusIndex - 1 + items.length) % items.length;
                updateActiveDescendant(items);
            } else if (e.key === 'Escape') {
                e.preventDefault();
                closeResults();
            }
        });

        document.addEventListener('click', (e) => {
            if (!container.contains(e.target)) {
                closeResults();
            }
        });
    });
};

export default searchModule;